var {
  legacy_createStore: createStore,
  combineReducers,
  applyMiddleware,
  compose,
} = require('redux');
var {
  authenticationReducer,
  distributionsReducer,
  transmitterTestSearchResultsReducer,
  soildDataReducer,
  rolesReducer,
  cropdDataReducer,
  fertilizerDataReducer,
  farmingTypeDataReducer,
  configurationDataReducer,
  generalDataReducer,
  meteorologicalStationsReducer,
  networkErrorReducer,
  mondayCasesReducer,
  unitsRecalcReducer,
} = require('@reducers/index.jsx');
var { newSeasonReducer } = require('@reducers/newSeasonReducer.js');
var thunkModule = require('redux-thunk');
// redux-thunk exports as named export 'thunk' in production builds
var thunk =
  thunkModule.default ||
  thunkModule.thunk ||
  (typeof thunkModule === 'function' ? thunkModule : null);

var subscriberModule = require('redux-subscriber');
var initSubscriber = subscriberModule.default || subscriberModule;

var configure = () => {
  var reducer = combineReducers({
    authentication_data: authenticationReducer,
    distribution_data: distributionsReducer,
    soil_data: soildDataReducer,
    crop_data: cropdDataReducer,
    fertilizer_data: fertilizerDataReducer,
    farming_type_data: farmingTypeDataReducer,
    configuration_data: configurationDataReducer,
    roles_data: rolesReducer,
    transmitter_test_search_results: transmitterTestSearchResultsReducer,
    general_data: generalDataReducer,
    meteorological_stations_data: meteorologicalStationsReducer,
    networkError: networkErrorReducer,
    monday_cases_data: mondayCasesReducer,
    units_recalc: unitsRecalcReducer,
    new_season_data: newSeasonReducer,
  });

  const composeEnhancers =
    (typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  var store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

  const subscribe = initSubscriber(store);

  return store;
};

module.exports = { configure };
